var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 176,
    viewBox: "0 0 38 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 3C21.5 1.61929 20.3807 0.5 19 0.5C17.6193 0.5 16.5 1.61929 16.5 3L21.5 3ZM17.2322 174.768C18.2085 175.744 19.7914 175.744 20.7678 174.768L36.6777 158.858C37.654 157.882 37.654 156.299 36.6777 155.322C35.7014 154.346 34.1184 154.346 33.1421 155.322L19 169.464L4.85786 155.322C3.88155 154.346 2.29863 154.346 1.32232 155.322C0.346013 156.299 0.346013 157.882 1.32232 158.858L17.2322 174.768ZM16.5 3L16.5 173L21.5 173L21.5 3L16.5 3Z",
    fill: "#C53EAE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.6ecf03a865944fddd3e84c4dcc9407c1.svg";
export { ForwardRef as ReactComponent };